import React, { useEffect } from 'react';
import { Cpu, HardDrive, MemoryStick } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const Performance = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('performance');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Comprehensive',
      icon: Cpu,
      description: 'Complete performance analysis with multiple diagnostic scripts covering CPU, Memory, and I/O.',
      scripts: getContentByCategory('Performance', 'Comprehensive')
    },
    {
      name: 'CPU',
      icon: Cpu,
      description: 'Monitor CPU usage, identify high CPU consuming queries, and optimize processor performance.',
      scripts: getContentByCategory('Performance', 'CPU')
    },
    {
      name: 'Memory',
      icon: MemoryStick,
      description: 'Analyze memory usage patterns, buffer pool efficiency, and memory pressure indicators.',
      scripts: getContentByCategory('Performance', 'Memory')
    },
    {
      name: 'IO',
      icon: HardDrive,
      description: 'Monitor disk I/O performance, identify bottlenecks, and analyze storage subsystem health.',
      scripts: getContentByCategory('Performance', 'IO')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Performance Monitoring</h1>
        <p className="page-description">
          Comprehensive collection of SQL Server performance monitoring scripts to help you identify 
          bottlenecks, optimize resource usage, and maintain peak database performance.
        </p>
      </div>

      <CategoryTabs 
        category="Performance"
        scripts={getContentByCategory('Performance')}
        articles={getContentByCategory('Performance', null, 'articles')}
        faqs={getContentByCategory('Performance', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default Performance;